import { Injectable,Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<User>;
  private Url: string;

  public currentUser: Observable<User>;
  
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url=baseUrl;
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) { 
    return this.http.post<any>(this.Url + 'api/users/authenticate', { "UserNickname": username, "UserPassword": password })
      .pipe(map(user => {
        // login successful if there's a jwt token in the response
        if (user && user.userToken) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
        }

        return user;
      }));
  }

  logout() {
    this.http.get<any>(this.Url + 'api/users/logout')
      .subscribe(
      res => console.log(res),
      err => console.log(err)
     );
    // remove user from local storage to log user out      
    localStorage.clear();
    this.currentUserSubject.next(null);
  }

  setCurrentUser(user: User) {
    this.currentUserSubject.next(user);
    return localStorage.setItem('currentUser', JSON.stringify(user));    
  }
}
